(function() {
  const path = window.location.pathname;

  
  const overrides = [
    {
      match: '/policies/privacy-policy',                
      newTitle: 'Privatlivspolitik'
    },
    {
      match: '/policies/refund-policy',
      newTitle: 'Retur- og refusionspolitik'
    },
    {
      match: '/policies/shipping-policy',
      newTitle: 'Forsendelsespolitik'
    },
    {
      match: '/policies/terms-of-service',
      newTitle: 'Vilkår for tjenesten'
    }
  ];

  
  const override = overrides.find(o => path.includes(o.match));
  if (!override) return;

  const newTitle = override.newTitle;

  
  document.title = newTitle;

  
  document.documentElement.style.visibility = 'hidden';

 
  const observer = new MutationObserver((mutations, obs) => {
    const h1 = document.querySelector('h1');
    if (h1) {
      h1.textContent = newTitle;
      document.documentElement.style.visibility = 'visible';
      obs.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
